import { render } from "./MyOrderList.vue?vue&type=template&id=f0652166"
import script from "./MyOrderList.vue?vue&type=script&lang=js"
export * from "./MyOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__